export const Interpolations = {
  NearestNeighbor: "NearestNeighbor",
  Linear:          "Linear",
  Cubic:           "Cubic",
  Lanczos:         "Lanczos",
};

export const GpuPresets = {
  High:   "high",
  Medium: "medium",
  Low:    "low",
};

export const AllInterpolations = Object.entries(Interpolations);
export const AllGpuPresets = Object.entries(GpuPresets);